export default __webpack_public_path__ + "static/media/Chat_Dual.cc54c384.svg";